import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@/shared/shared.module';

import { TennisTimelineComponent } from '@components/match/timeline/tennis/tennis-timeline.component';
import { AmericanFootballTimelineComponent } from '@components/match/timeline/american-football/american-football-timeline.component';
import { BasketballTimelineComponent } from '@components/match/timeline/basketball/basketball-timeline.component';
import { BaseballMlbTimelineComponent } from '@components/match/timeline/baseball/baseball-mlb-timeline.component';
import { BaseTimelineComponent } from '@components/match/timeline/base.component';
import { AdTimelineDirective } from '@components/match/timeline/timeline.directive';
import { DefaultTimelineComponent } from '@components/match/timeline/default/default-timeline.component';
import { DartsTimelineComponent } from '@components/match/timeline/darts/darts-timeline.component';
import { CricketTimelineComponent } from '@components/match/timeline/cricket/cricket-timeline.component';
import { PremiumTimelinesComponent } from '@components/match/premium-timelines/premium-timelines.component';

const TIMELINE_COMPONENTS = [
    TennisTimelineComponent,
    AmericanFootballTimelineComponent,
    BasketballTimelineComponent,
    BaseballMlbTimelineComponent,
    BaseTimelineComponent,
    AdTimelineDirective,
    DefaultTimelineComponent,
    DartsTimelineComponent,
    CricketTimelineComponent,
    PremiumTimelinesComponent,
];

@NgModule({
    declarations: TIMELINE_COMPONENTS,
    imports: [CommonModule, SharedModule],
    exports: TIMELINE_COMPONENTS,
})
export class TimelineModule {}
